'use strict';

import * as moment from 'moment';

const ACTION_TYPE_LABELS = ({ sourceType, actionType, source }) => {
  if (sourceType == 'Assignation' && actionType == 'update:status') {
    if (source.status === 'done') {
      return 'hecha';
    } else if (source.status === 'notDone') {
      return 'no hecha';
    }
  }
  if (sourceType == 'Assignation' && actionType == 'update:reassign') {
    return 'reasignacion';
  }

  if (sourceType == 'Task') {
    if (actionType == 'update:completedAt') {
      if (source.completedAt) {
        return 'hecha';
      } else {
        return 'no hecha';
      }
    } else if (actionType == 'update:dueDate') {
      return 'reasignacion';
    }
  }

  const TYPES = {
    create: 'nuevo',
    update: 'actualizacion',
  };
  return TYPES[actionType];
};

const TYPE_LABELS = {
  Assignation: ({ source, actionType }) =>
    `Asignacion (${ACTION_TYPE_LABELS({
      sourceType: 'Assignation',
      actionType,
      source
    })})`,
  OperationComment: () => `Comentario`,
  Task: ({ source, actionType }) =>
    `Agenda (${ACTION_TYPE_LABELS({
      sourceType: 'Task',
      actionType,
      source
    })})`,
};

const DESCRIPTIONS = {
  Assignation: ({ source, actionType }) => {
    if (actionType === 'update:status' && source.status === 'done') {
      return `Hecha: ${moment(source.statusDate).format('DD/MM/YYYY')} - ${
        source.statusComments
      }`;
    } else if (actionType === 'update:status' && source.status === 'notDone') {
      return `No Hecha: ${moment(source.statusDate).format('DD/MM/YYYY')} - ${
        source.statusComments
      }`;
    } else if (actionType === 'update:reassign') {
      return `Reasignacion: ${moment(source.statusDate).format('DD/MM/YYYY')} - ${
        source.statusComments
      }`;
    } else {
      return `Fecha de asignacion: ${moment(source.date).format('DD/MM/YYYY')} \
 - ${source.comments}`;
    }
  },
  OperationComment: ({ source }) => source.comment,
  Task: ({ source, actionType }) => {
    if (actionType === 'update:dueDate') {
      return `Reasignada: ${moment(source.dueDate).format('DD/MM/YYYY')} - ${
        source.description
      }`;
    } else if (actionType === 'update:completedAt' && source.completedAt) {
      return `Hecha: ${moment(source.completedAt).format('DD/MM/YYYY')} - \
${source.description} (${source.completedComments})`;
    } else if (actionType == 'create') {
      return `Vencimiento: ${moment(source.dueDate).format('DD/MM/YYYY')} \
 - ${source.description}`;
    }
  },
};

export function CronologyTypeDirective() {
  return {
    restrict: 'E',
    scope: {
      sourceType: '<',
      source: '<',
      actionType: '<'
    },
    link: function(scope, element, attrs, controller) {
      const { sourceType, source, actionType } = scope;
      scope.cronologyTypeLabel = TYPE_LABELS[sourceType]({
        source,
        actionType
      });
    },
    template: '{{ cronologyTypeLabel }}'
  };
}

export function CronologyDescriptionDirective() {
  return {
    restrict: 'E',
    scope: {
      sourceType: '<',
      source: '<',
      actionType: '<'
    },
    link: function(scope, element, attrs, controller) {
      const { sourceType, source, actionType } = scope;
      scope.cronologyDescription = DESCRIPTIONS[sourceType]({
        source,
        actionType
      });
    },
    template: '{{ cronologyDescription }}'
  };
}
